class CustomScrollBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
          this.init();
      }, 1500)
    })
  }

  init(){
    const isMobile = window.matchMedia("(max-width: 749px)").matches;
    if(!isMobile){
      this.remove();
      return
    }
    this.attachShadow({ mode: "open" });

    this.targetElId = this.dataset.targetId;
    this.trackColor = this.dataset.trackColor || "#f2f2f2";
    this.trackWidth = this.dataset.trackWidth || "6px";
    this.thumbColor = this.dataset.thumbColor || "#bba8a8";
    this.targetEl = document.querySelector(`#${this.targetElId}`);

    const style = document.createElement("style");
    style.textContent = `
      .custom-scrollbar {
        width: ${this.trackWidth};
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
      }

      .custom-scrollbar__track {
        width: 100%;
        height: 100%;
        background-color: ${this.trackColor};
      }

      .custom-scrollbar__thumb {
        width: 100%;
        background-color: ${this.thumbColor};
        border-radius: ${this.trackWidth};
        position: absolute;
        top: 0;
        animation: top 0.25s ease-in;

      }

      .custom-scrollbar__thumb::hover {
        background-color: red;
      }
    `;
    this.shadowRoot.appendChild(style);

    const style2 = document.createElement("style");
    style2.textContent = `
      .prevent-scroll {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }
    `;

    document.head.appendChild(style2);

    if (!this.targetEl) {
      console.log(`CustomScrollBar: target element with id "${this.targetElId}" not found`,this, this.dataset.targetId);
      return;
    }

    setTimeout(() => {
      this.setupScrollbar();
      this.setupCartUpdateListener();
    }, 100);
  }

  setupCartUpdateListener() {
    document.addEventListener('theme:cart:update', () => {
      console.log('Cart updated - reinitializing scrollbar');
      setTimeout(() => {
        this.setupScrollbar();
      }, 500); 
    });

    document.addEventListener('theme:cart:build', () => {
      setTimeout(() => {
        this.setupScrollbar();
      }, 500);
    });
  }

  reinitializeScrollbar() {
    this.setScrollThumbHeight();
    this.moveScrollThumb();
    console.log('Scrollbar reinitializated');
  }

  setupScrollbar() {
    if (!this.targetEl || !this.shadowRoot) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.setTargetElCSS();
          this.setScrollThumbHeight();
          this.attachScrollListener();
        }
      });
    });

    observer.observe(this.targetEl);

    this.shadowRoot.innerHTML += `
      <div class="custom-scrollbar">
        <div class="custom-scrollbar__track">
          <div class="custom-scrollbar__thumb"></div>
        </div>
      </div>
    `;
  }

  attachScrollListener() {
    this.targetEl.addEventListener("scroll", this.handleScroll.bind(this), { passive: true });
    this.handleScroll();
  }

  handleScroll() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
    
    this.animationFrame = requestAnimationFrame(() => {
      console.log('Scroll event fired!', this.targetEl.scrollTop);
      this.moveScrollThumb();
    });
  }

  moveScrollThumb() {
    const scrollBarThumb = this.shadowRoot.querySelector(".custom-scrollbar__thumb");
    const scrollBarTrack = this.shadowRoot.querySelector(".custom-scrollbar__track");
    const scrollBarTrackHeight = scrollBarTrack.offsetHeight;
    const scrollThumbHeight = scrollBarThumb.offsetHeight;
    
    const availableTrackHeight = scrollBarTrackHeight - scrollThumbHeight;
    
    const maxScrollTop = this.targetEl.scrollHeight - this.targetEl.offsetHeight;
    const scrollPercentage = Math.min(Math.max(this.targetEl.scrollTop / maxScrollTop, 0), 1);
    
    const scrollThumbTop = Math.round(scrollPercentage * availableTrackHeight);
    
    if (!scrollBarThumb.style.transition) {
      scrollBarThumb.style.transition = 'top 0.1s ease-out';
    }
    
    scrollBarThumb.style.top = `${scrollThumbTop}px`;
  }

  setTargetElCSS() {
    this.targetEl.style.overflowY = "scroll";
    this.targetEl.style["-ms-overflow-style"] = "none";
    this.targetEl.style.scrollbarWidth = "none";
  }

  setScrollThumbHeight() {
    const scrollBarTrack = this.shadowRoot.querySelector(
      ".custom-scrollbar__track"
    );
    const scrollBarThumb = this.shadowRoot.querySelector(
      ".custom-scrollbar__thumb"
    );

    const scrollBarTrackHeight = scrollBarTrack.offsetHeight;

    const targetElHeight = this.targetEl.offsetHeight;

    const targetElScrollHeight = this.targetEl.scrollHeight;

    const scrollThumbHeight =
      (targetElHeight / targetElScrollHeight) * scrollBarTrackHeight;

    scrollBarThumb.style.height = `${scrollThumbHeight}px`;

    let isDragging = false;
    let currentY;
    scrollBarThumb.addEventListener("mousedown", (e) => {
      isDragging = true;
      currentY = e.clientY;
      this.preventContentHighlight("remove");
    });
    document.addEventListener("mouseup", () => {
      isDragging = false;
      this.preventContentHighlight("add");
    });
    document.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      const deltaY = e.clientY - currentY;
      currentY = e.clientY;
      this.targetEl.scrollTop +=
        deltaY * (targetElScrollHeight / scrollBarTrackHeight);
    });
  }

  preventContentHighlight(action) {
    if (action) {
      this.targetEl.classList.add("prevent-scroll");
    } else {
      this.targetEl.classList.add("prevent-scroll");
    }
  }
}

customElements.define("custom-scrollbar", CustomScrollBar);